import React from 'react';
import styles from './AboutSection.module.css';
import pellSocialX from '../assets/icon/pell_social_x.svg';
import pellSocialD from '../assets/icon/pell_social_discord.svg';
import pellSocialT from '../assets/icon/pell_social_telegram.svg';
import pellLogo from '../assets/icon/pell_logo.svg';
import pellLogoSmall from '../assets/icon/pell_logo_small.svg';
import logoIcon140 from "../assets/icon/logo_icon_140.svg";
import {useScreenDetector} from "../hooks/useScreenDetector";
import {useTranslation} from "react-i18next";

const AboutSection: React.FC = () => {
    const {isMobile} = useScreenDetector();
    const { t } = useTranslation();

    const socialLinks = [
        {name: 'X', icon: pellSocialX, link: 'https://twitter.com/Pell_Network'},
        {name: 'Discord', icon: pellSocialD, link: 'https://discord.com/invite/pell-network'},
        {name: 'Telegram', icon: pellSocialT, link: 'https://t.me/Pell_Network'},
    ];

    return (
        <section className={styles.aboutContainer}>
            <div className={styles.aboutSection}>
                <div className={styles.aboutContent}>
                    <h2 className={styles.title}>{t('pellAbout')}</h2>
                    <p className={styles.description}>
                        {t('pellBreaking')}
                    </p>
                    <p className={styles.description} style={{fontSize: '10px'}}>
                        {t('pellBreakingNote')}
                    </p>
                    <div className={styles.socialLinks}>
                        <p>{t('checkout')}</p>
                        <div className={styles.iconContainer}>
                            {socialLinks.map((platform, index) => (
                                <a href={platform.link} key={index} className={styles.socialIcon}
                                   aria-label={`Pell Network ${platform.name}`} target="_blank">
                                    <img src={platform.icon} alt=""/>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
                <img
                    src={isMobile ? pellLogoSmall : pellLogo}
                    className={styles.aboutImage}
                />
            </div>
            <div className={styles.satoshiAppSection}>
                <img
                    src={logoIcon140}
                    className={styles.appLogo}/>
                <div className={styles.contentWrapper}>
                    <h2 className={styles.sectionTitle}>{t('numberOne')}</h2>
                    <p className={styles.description}>
                        {t('trusted')}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;